import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  async getActiveLogs({ commit }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.logsApiPath.getActiveLogs}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
  },
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
